import { Resolve} from "@angular/router";
import {inject, Injectable} from "@angular/core";
import {StateService} from "./Services/state/state.service";
import {environment} from "../environments/environment";
import {DOCUMENT} from "@angular/common";

@Injectable({ providedIn: 'root' })
export class ChatUrlResolver implements Resolve<string> {
  resolve(): string {
    return environment.chatUrl;
  }
}

@Injectable({ providedIn: 'root' })
export class DepartmentIdResolver implements Resolve<string> {
  constructor(private stateService: StateService) {}
  resolve(): string {
    return this.stateService.userInfo()?.twixor_department_id ?? environment.chatDepartmentId;
  }
}

@Injectable({ providedIn: 'root' })
export class CustomerIdResolver implements Resolve<string | null> {
  constructor(private stateService: StateService) {}

  resolve(): string | null {
    const userInfo = this.stateService.userInfo();
    console.log(`resolving user phone number: ${userInfo?.cell_phone}`)
    return JSON.stringify(userInfo?.cell_phone ?? null);
  }
}

@Injectable({ providedIn: 'root' })
export class EIdResolver implements Resolve<string> {
  resolve(): string {
    return '103';
  }
}

@Injectable({ providedIn: 'root' })
export class CountryCodeResolver implements Resolve<string> {
  resolve(): string {
    return '+1';
  }
}

@Injectable({ providedIn: 'root' })
export class CustomerDetailsResolver implements Resolve<any> {
  constructor(private stateService: StateService) {}

  resolve(): any {
    const userInfo = this.stateService.userInfo();
    if (!userInfo) return null;

    return {
      Custumerknostosid: userInfo.knostos_id,
      CustumerProfilePicture: userInfo.avatar,
      Custumername: userInfo.first_name,
      Custumerlastname: userInfo.last_name,
      Custumercellnumber: userInfo.cell_phone,
      Custumeremail: userInfo.email,
      Custumerfacility: userInfo.facilities,
    };
  }
}

@Injectable({ providedIn: 'root' })
export class ChatColorsResolver implements Resolve<any> {
  private document = inject(DOCUMENT)
  private stateService = inject(StateService);
  resolve(): any {
    const userInfo = this.stateService.userInfo();
    if (!userInfo) return null;
    const doc = this.document.documentElement;
    const colors = {
      '--chat-primary-color': doc.style.getPropertyValue('--primary-brand-color'),
      '--chat-primary-font-color': doc.style.getPropertyValue('--text-on-primary'),
      '--chats-font-color': doc.style.getPropertyValue('--text-primary-color'),
      '--message-background-right': '#f5f5f5ff',
      '--message-background-left': '#d5d5d5ff',
      '--message-font-color': doc.style.getPropertyValue('--text-primary-color'),
    };

    const chatColors = {
      '--chat-primary-color': doc.style.getPropertyValue('--primary-brand-color'),
      '--chat-primary-font-color': doc.style.getPropertyValue('--text-on-primary'),
      '--message-background-right': doc.style.getPropertyValue('--primary-brand-color'),
      // '--chats-font-color': doc.style.getPropertyValue('--text-on-primary'),
      '--chats-font-color': '#ffffff',
      '--message-background-left': doc.style.getPropertyValue('--app-background-color'),
      '--message-font-color': doc.style.getPropertyValue('--text-primary-color'),
    }

    return colors
  }
}



